import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import { emptyFormState } from '../emptyState';
import { postStatus } from '../status';
import { postToken } from 'api';

// Then, handle actions in your reducers:
const tokenSlice = createSlice({
  name: 'token',
  emptyFormState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    tokenFromCache: (state, { payload }) => {
      state.status = 'FROM_CACHE';
      state.payload = payload;
      state.fetching = false;
    },
    tokenPostStart: (state) => {
      state.status = postStatus.POST_START;
      state.fetching = true;
    },
    tokenPostSuccess: (state, { payload }) => {
      state.status = postStatus.POST_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    tokenPostFail: (state, { payload }) => {
      state.status = postStatus.POST_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    tokenReset: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
      state.error = false;
      Cookies.remove('token');
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const { tokenFromCache, tokenPostStart, tokenPostSuccess, tokenPostFail, tokenReset } = tokenSlice.actions;

// The reducer
export const tokenReducer = tokenSlice.reducer;

// Asynchronous thunk action
export const tokenPost = (data) => (dispatch) => {
  dispatch(tokenPostStart());

  postToken(data)
    .then((payload) => {
      Cookies.set('token', payload.data, { expires: 365 });
      dispatch(tokenPostSuccess(payload.data));
    })
    .catch((error) => {
      dispatch(tokenPostFail(error));
    });
};

export const setToken = (token) => (dispatch) => {
  Cookies.set('token', token, { expires: 365 });
  dispatch(tokenPostSuccess(JSON.parse(token)));
};
